import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { NumericFormat } from "react-number-format";

const FormattedInputs = React.forwardRef(
  (
    {
      name,
      control,
      onErrorCheck,
      clear,
      setValue,
      onDataPass,
      sharedValue,
      ...props
    },
    ref
  ) => {
    // Custom change handler to format input value

    const onChangeHandler = (e, onChange) => {
      // console.log(e.target.value);
      onChange(e.target.value);
      onDataPass(name, e.target.value); // Call the parent's function with data as argument
    };

    useEffect(() => {
      if (clear) {
        setValue(name, ""); // Clear form control state in react-hook-form
      }
    }, [clear, name, setValue]);

    // Use sharedValue to set all input fields if sharedValue changes
    useEffect(() => {
      // console.log(sharedValue);
      if (sharedValue !== undefined) {
        setValue(name, sharedValue); // Update value to sharedValue
      }
    }, [sharedValue, name, setValue]);

    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <NumericFormat
            value={value}
            displayType="input" // Make it editable
            thousandSeparator={true}
            prefix="RM"
            decimalScale={2} // Limit to 2 decimal places
            fixedDecimalScale={true} // Ensure 2 decimal places (e.g., 123.50)
            customInput={TextField} // Use Material-UI TextField for input
            variant="outlined" // Material-UI variant for styling
            fullWidth // Make the input take full width
            helperText={error ? error.message : onErrorCheck} // Show error message if invalid
            error={Boolean(error)} // Set error state
            onChange={(e) => onChangeHandler(e, onChange)}
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                fontSize: "16px",
                borderRadius: "25px",
                color: "black", // Set input text color
                backgroundColor: "white", // Set background color
                "& fieldset": {
                  borderColor: "#ccc", // Default border color
                },
                "&:hover fieldset": {
                  borderColor: "#999", // Border color on hover
                },
                // "&.Mui-focused fieldset": {
                //   borderColor: "transparent", // Border color on focus
                //   outline: "none", // Remove outline on focus
                // },
              },
            }}
          />
        )}
      />
    );
  }
);

export default FormattedInputs;
